import { initStore } from './ducks/redux';

const runtime = initStore();

export const { store, persistor, persistStore } = runtime;
